import React from 'react';
import { observer } from 'mobx-react';
import { FlexDiv } from '../../design-system/containers';
import { TextLead } from '../../design-system/texts';

function EmailAvatar({ ui, t, desktopOnly, mobileOnly }) {
    const { email } = ui;
    const { from_name, from_initials, avatar_background_color } = email;

    let initials = '';
    if (from_initials && t) {
        initials = t(from_initials);
    } else if (from_name && t) {
        initials = t(from_name)
            .split(' ')
            .map((n) => n[0])
            .join('');
    } else if (from_name) {
        initials = from_name
            .split(' ')
            .map((n) => n[0])
            .join('');
    }

    return (
        <FlexDiv
            borderRadius="50"
            backgroundColor={avatar_background_color || '#2E56E4'}
            padding={8}
            height={40}
            minWidth={40}
            width={40}
            alignCenter
            justifyCenter
            desktopOnly={desktopOnly}
            mobileOnly={mobileOnly}
        >
            <TextLead color="white" bold>
                {initials}
            </TextLead>
        </FlexDiv>
    );
}

export default observer(EmailAvatar);
